import React from "react";
import { Route, Routes } from "react-router-dom";
import { LoginPage } from "../pages/LoginPage";

/**
 * Router de autenticación
 *
 * @returns {React.Component} Router de autenticación
 */
export const AuthRouter = () => {
  return (
    <Routes>
      <Route exact path="/login" element={<LoginPage />} />
    </Routes>
  );
};
